import { locales } from "../../../../constants/constants";

/**
 * determines if the percentile is behind the threshold
 * @param {number} percentile - the percentile for the student
 * @param {string} metric - the metric selected
 * @param {number} grade - the benchmark grade
 * @param {string} locale - the locale selected
 * @returns {boolean} - true if the percentile is behind the threshold
 */
export default function isBehind(percentile, metric, grade, locale){
  if(locale !== locales.EN_US) return false;
  if(metric !== "ARM") return false;
  if(grade < 3 || grade > 6) return false;

  const BEHIND_THRESHOLD = 5;
  return percentile < BEHIND_THRESHOLD;
}